import PropTypes from "prop-types";

export default PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string,
  optionalLabel: PropTypes.string,
});
